'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');

var Shell = require('./Shell.jsx');
var DesktopShell = require('./DesktopShell.jsx');
var MainStage = require('./MainStage.jsx');
var pageHelper = require('../helper/pageHelper');
var Comments = require('./Comments.jsx');

var Workspace = React.createClass({
  propTypes: {
    domSize: React.PropTypes.object.isRequired,
    meta: React.PropTypes.object.isRequired,
    pages: React.PropTypes.object,
    current: React.PropTypes.object.isRequired,
    target: React.PropTypes.object,
    animation: React.PropTypes.object,
    app: React.PropTypes.object.isRequired,
    showComments: React.PropTypes.bool.isRequired,
    scale: React.PropTypes.number.isRequired,
    shell: React.PropTypes.string.isRequired,
    canFix: React.PropTypes.bool.isRequired,
    onRedirectTo: React.PropTypes.func.isRequired,
    onOpenPage: React.PropTypes.func.isRequired,
    onShowRemark: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      scrollTop: 0
    };
  },
  componentWillReceiveProps: function (nextProps) {
    if (this.props.current.ID !== nextProps.current.ID) {
      var scrollDom = ReactDOM.findDOMNode(this.refs.scroll);
      if (scrollDom) {
        scrollDom.scrollTop = 0;
        scrollDom.scrollLeft = 0;
      }
    }
  },
  render: function () {
    var page = this.props.current;
    var target = this.props.target;
    var commentComponents;
    var pageInfo = pageHelper.getPageDeviceMetaInfo(page, this.props.meta, this.props.shell); // this.getPageMetaInfo(page);
    var deviceStyle = {
      width: pageInfo.width,
      height: pageInfo.height,
      transform: 'scale(' + this.props.scale + ')'
    };
    var screenSize = {
      width: pageInfo.pageSize.x,
      height: pageInfo.pageSize.y
    };

    var deviceScrollStyle = {
      width: 6000 * this.props.scale, // 设置为 6000 让滚动条显示到上面
      height: pageInfo.height * this.props.scale,
      // overflowY: 'hidden',
      // overflowX: 'auto'
    };
    var deviceScrollViewStyle = {};
    if (pageInfo.height * this.props.scale < this.props.domSize.height) {
      deviceScrollViewStyle.alignItems = 'center';
    } else {
      deviceStyle.transformOrigin = 'top left'; // 此时从左上角放大
    }

    commentComponents = _.filter(page.controls.control, function (comp) {
      return comp.isCommentCom;
    });
    return (
      <div className="preview-container" onClick={this._onWorkerspaceClick}>
        <div className="device-scroll-view" ref="scroll" style={deviceScrollViewStyle}>
          <div className="device-scroll-content" style={deviceScrollStyle}>
            <div className="device" style={deviceStyle}>
              {
                ['iPhone', 'Android', 'iPad', 'Tablet'].indexOf(this.props.shell) !== -1 &&
                <Shell
                  size={{
                    width: pageInfo.width,
                    height: pageInfo.height,
                    left: pageInfo.position.x,
                    top: pageInfo.position.y
                  }}
                  shell={this.props.shell}
                  isHorizontal={pageInfo.isHorizontal}
                />
              }
              {
                this.props.shell === 'desktop' &&
                <DesktopShell
                  size={{
                    width: pageInfo.width,
                    height: pageInfo.height
                  }}
                  title={page.title}
                />
              }
              <MainStage
                position={pageInfo.position}
                size={screenSize}
                current={page}
                target={target}
                animation={this.props.animation}
                pages={this.props.pages}
                showComments={this.props.showComments}
                canFix={this.props.canFix}
                onRedirectTo={this.props.onRedirectTo}
                onOpenPage={this.props.onOpenPage}
                onPageScroll={this._onPageScroll}
                onShowRemark={this.props.onShowRemark}
                orientation={this.props.meta.orientation}
              />
              {this.props.showComments &&
              <Comments
                position={pageInfo.position}
                scrollTop={this.state.scrollTop}
                components={commentComponents}/>}
            </div>
          </div>
        </div>
      </div>
    );
  },
  _onPageScroll: function (scrollTop) {
    this.setState({
      scrollTop: scrollTop
    });
  },

  _onWorkerspaceClick: function (e) {
    $('.page').trigger('onScreenClick', e);
  }
});

module.exports = Workspace;



/** WEBPACK FOOTER **
 ** ./src/views/Workspace.jsx
 **/